export enum EventName {
  // Feed
  POST_CREATE = 'POST_CREATE',
  POST_DELETE = 'POST_DELETE',
  POST_UPDATE = 'POST_UPDATE',
  POST_FEED_VIEW = 'POST_FEED_VIEW',
  POST_DETAILS_VIEW = 'POST_DETAILS_VIEW',
  POST_MENTION = 'POST_MENTION',
  POST_COMMENT = 'POST_COMMENT',
  POST_REACTION = 'POST_REACTION',
  POST_COMMENT_REACTION = 'POST_COMMENT_REACTION',
  POST_COMMENT_MENTION = 'POST_COMMENT_MENTION',
  // Groups
  GROUPS_POST_VIEWED = 'GROUPS_POST_VIEWED',
  GROUPS_POST_COMMENTED = 'GROUPS_POST_COMMENTED',
  GROUPS_POST_COMMENT_REACTIONED = 'GROUPS_POST_COMMENT_REACTIONED',
  GROUPS_POST_CREATED = 'GROUPS_POST_CREATED',
  GROUPS_POST_UPDATED = 'GROUPS_POST_UPDATED',
  GROUPS_POST_MENTIONED = 'GROUPS_POST_MENTIONED',
  GROUPS_POST_COMMENT_MENTIONED = 'GROUPS_POST_COMMENT_MENTIONED',
  GROUPS_POST_COMMENT_UPDATED = 'GROUPS_POST_COMMENT_UPDATED',
  GROUPS_POST_DELETED = 'GROUPS_POST_DELETED',
  GROUPS_POST_DETAILS_VIEWED = 'GROUPS_POST_DETAILS_VIEWED',
  GROUPS_POST_REACTIONED = 'GROUPS_POST_REACTIONED',
  GROUPS_POST_POLL_CREATED = 'GROUPS_POST_POLL_CREATED',
  GROUPS_POST_POLL_ANSWERED = 'GROUPS_POST_POLL_ANSWERED',
  GROUPS_REQUESTED = 'GROUPS_REQUESTED',
  GROUPS_REQUEST_ACCEPTED = 'GROUPS_REQUEST_ACCEPTED',
  GROUPS_REQUEST_ACCEPTED_ALL = 'GROUPS_REQUEST_ACCEPTED_ALL',
  GROUPS_REQUEST_DECLINED = 'GROUPS_REQUEST_DECLINED',
  GROUPS_REQUEST_DECLINED_ALL = 'GROUPS_REQUEST_DECLINED_ALL',
  // Marketplace
  POST_MARKETPLACE_CREATE = 'POST_MARKETPLACE_CREATE',
  POST_MARKETPLACE_DELETE = 'POST_MARKETPLACE_DELETE',
  POST_MARKETPLACE_UPDATE = 'POST_MARKETPLACE_UPDATE',
  POST_MARKETPLACE_VIEW = 'POST_MARKETPLACE_FEED_VIEW',
  POST_MARKETPLACE_DETAILS_VIEW = 'POST_MARKETPLACE_DETAILS_VIEW',
  POST_MARKETPLACE_MENTION = 'POST_MARKETPLACE_MENTION',
  POST_MARKETPLACE_COMMENT = 'POST_MARKETPLACE_COMMENT',
  POST_MARKETPLACE_REACTION = 'POST_MARKETPLACE_REACTION',
  POST_MARKETPLACE_COMMENT_REACTION = 'POST_MARKETPLACE_COMMENT_REACTION',
  POST_MARKETPLACE_COMMENT_MENTION = 'POST_MARKETPLACE_COMMENT_MENTION', // Poll
  POST_POLL_CREATE = 'POST_POLL_CREATE',
  POST_POLL_ANSWER = 'POST_POLL_ANSWER',
  // Surveys
  SURVEY_ANSWER = 'SURVEY_ANSWER',
  // News
  ARTICLE_VIEW = 'ARTICLE_VIEW',
  // Org Chart
  ORG_CHART_VIEW = 'ORG_CHART_VIEW',
  // Tickets
  TOPIC_TICKET_CREATE = 'TOPIC_TICKET_CREATE',
  TOPIC_TICKET_ASSIGN = 'TOPIC_TICKET_ASSIGN',
  TOPIC_TICKET_CLOSE = 'TOPIC_TICKET_CLOSE',
  TOPIC_TICKET_RATING = 'TOPIC_TICKET_RATING',
  // Chats
  CHAT_SINGLE_CREATE = 'CHAT_SINGLE_CREATE',
  CHAT_GROUP_CREATE = 'CHAT_GROUP_CREATE',
  CHAT_GROUP_LEAVE = 'CHAT_GROUP_LEAVE',
  CHAT_SINGLE_MESSAGE_SENT = 'CHAT_SINGLE_MESSAGE_SENT',
  CHAT_GROUP_MESSAGE_SENT = 'CHAT_GROUP_MESSAGE_SENT',
  CHAT_SINGLE_TSPENT = 'CHAT_SINGLE_TSPENT',
  CHAT_GROUP_TSPENT = 'CHAT_GROUP_TSPENT',
  CHAT_MESSAGE_REACTION = 'CHAT_MESSAGE_REACTION',
  // Forms
  FORM_START = 'FORM_START',
  FORM_REGULAR_FILL = 'FORM_REGULAR_FILL',
  FORM_REGULAR_EDIT = 'FORM_REGULAR_EDIT',
  FORM_APPROVAL_FILL = 'FORM_APPROVAL_FILL',
  FORM_APPROVAL_EDIT = 'FORM_APPROVAL_EDIT',
  FORM_APPROVAL_CLOSE = 'FORM_APPROVAL_CLOSE',
  FORM_REGULAR_CLOSE = 'FORM_REGULAR_CLOSE',
  // Files
  FILE_VIEW = 'FILE_VIEW',
  // Trainings
  TRAINING_COMPLETE = 'TRAINING_COMPLETE',
  TRAINING_SECTION_COMPLETE = 'TRAINING_SECTION_COMPLETE',
  TRAINING_SECTION_VIEW = 'TRAINING_SECTION_VIEW',
  // Onboarding
  ONBOARDING_TASK_COMPLETE = 'ONBOARDING_TASK_COMPLETE',
  ONBOARDING_CATEGORY_COMPLETE = 'ONBOARDING_CATEGORY_COMPLETE',
  // knowledge library
  WIDGET_LIBRARY_VIEW = 'WIDGET_LIBRARY_VIEW',
  WIDGET_SHORTCUT_VIEW = 'WIDGET_SHORTCUT_VIEW',
  // Profile
  USER_PROFILE_VIEW = 'USER_PROFILE_VIEW',
  USER_PROFILE_UPDATE = 'USER_PROFILE_UPDATE',
  USER_PROFILE_FIELDS_UPDATE = 'USER_PROFILE_FIELDS_UPDATE',
  USER_PROFILE_PICTURE_UPDATE = 'USER_PROFILE_PICTURE_UPDATE',
  USER_PROFILE_COVER_UPDATE = 'USER_PROFILE_COVER_UPDATE',
  SUPPORT_APP_CONTACTED = 'SUPPORT_APP_CONTACTED',
  // General
  USER_APP_USE = 'USER_APP_USE',
  USER_MODULE_USE = 'USER_MODULE_USE',
  USER_LOGIN = 'USER_LOGIN',
  USER_LOGOUT = 'USER_LOGOUT',
  USER_LOGOUT_INACTIVITY = 'USER_LOGOUT_INACTIVITY',
  USER_PHONE_CONFIRMED = 'USER_PHONE_CONFIRMED',
  USER_RECEIVE_CODE = 'USER_RECEIVE_CODE',
  USER_VALIDATE_CODE = 'USER_VALIDATE_CODE',
  // Birthdays
  BIRTHDAYS_VIEW = 'BIRTHDAYS_VIEW',
  BIRTHDAYS_VIEW_NEXT = 'BIRTHDAYS_VIEW_NEXT',
  // Documents
  DOCUMENT_VIEW = 'DOCUMENT_VIEW',
  DOCUMENT_SIGN = 'DOCUMENT_SIGN',
  // Acknowledgements
  ACKNOW_GIVE = 'ACKNOW_GIVE',
  ACKNOW_REACTION = 'ACKNOW_REACTION',
  ACKNOW_COMMENT = 'ACKNOW_COMMENT',
  ACKNOW_EXCHANGE = 'ACKNOW_EXCHANGE',
  // New Communities
  INSTANCE_CREATE = 'INSTANCE_CREATE',
  //Bubbles
  NEW_FORM_CHAT_CREATED_BUBBLES = 'NEW_FORM_CHAT_CREATED_BUBBLES',
  APPROVAL_FORM_TRANSITIONED_BUBBLES = 'APPROVAL_FORM_TRANSITIONED_BUBBLES',
  APPROVAL_FORM_CLOSED_BUBBLES = 'APPROVAL_FORM_CLOSED_BUBBLES',
  NEW_ASSIGMENT_OF_FORM_AGENT_BUBBLES = 'NEW_ASSIGMENT_OF_FORM_AGENT_BUBBLES',
  FORM_APPROVAL_STEP_ASSIGNED_BUBBLES = 'FORM_APPROVAL_STEP_ASSIGNED_BUBBLES',
  DELETE_UNASSIGNED_FORM_CHAT_BUBBLES = 'DELETE_UNASSIGNED_FORM_CHAT_BUBBLES',
  ADDED_SUBORDINATE_BUBBLES = 'ADDED_SUBORDINATE_BUBBLES',
  REMOVED_SUBORDINATE_BUBBLES = 'REMOVED_SUBORDINATE_BUBBLES',
  APPROVAL_WORKFLOW_STEP_RESPONSIBLE_ADDED_BUBBLES = 'APPROVAL_WORKFLOW_STEP_RESPONSIBLE_ADDED_BUBBLES',
  APPROVAL_WORKFLOW_STEP_RESPONSIBLE_REMOVED_BUBBLES = 'APPROVAL_WORKFLOW_STEP_RESPONSIBLE_REMOVED_BUBBLES',
  // Vacations
  TIME_OFF_APPROVAL_RESOLVED = 'TIME_OFF_APPROVAL_RESOLVED',
  TIME_OFF_REQUEST_STARTED = 'TIME_OFF_REQUEST_STARTED',
  TIME_OFF_REQUEST_SUBMITTED = 'TIME_OFF_REQUEST_SUBMITTED',
  TIME_OFF_REPORT_DOWNLOAD = 'TIME_OFF_REPORT_DOWNLOAD',
  TIME_OFF_CALENDAR_MONTHLY_NAVIGATION = 'TIME_OFF_CALENDAR_MONTHLY_NAVIGATION',
  TIME_OFF_DOCUMENTATION_ATTACHED = 'TIME_OFF_DOCUMENTATION_ATTACHED',
  TIME_OFF_MANAGE_BALANCE_TAB_VISITED = 'TIME_OFF_MANAGE_BALANCE_TAB_VISITED',
  TIME_OFF_MANAGE_CALENDAR_TAB_VISITED = 'TIME_OFF_MANAGE_CALENDAR_TAB_VISITED',
  TIME_OFF_MANAGE_REQUESTS_TAB_VISITED = 'TIME_OFF_MANAGE_REQUESTS_TAB_VISITED',
  TIME_OFF_MANAGEMENT_TABS_FILTER_APPLIED = 'TIME_OFF_MANAGEMENT_TABS_FILTER_APPLIED',
  TIME_OFF_REQUESTS_SORTED = 'TIME_OFF_REQUESTS_SORTED',
  // Performance Review
  PERF_REV_REVIEW_RECEIVED = 'PERF_REV_REVIEW_RECEIVED',
  PERF_REV_REVIEW_COMPLETED = 'PERF_REV_REVIEW_COMPLETED',
  PERF_REV_REVIEW_SHARED = 'PERF_REV_REVIEW_SHARED',
  // Workflows
  WORKFLOW_REQUEST_STARTED = 'WORKFLOW_REQUEST_STARTED',
  WORKFLOW_REQUEST_SELECTED = 'WORKFLOW_REQUEST_SELECTED',
  WORKFLOW_REQUEST_FILLED = 'WORKFLOW_REQUEST_FILLED',
  WORKFLOW_REQUEST_COMPLETED = 'WORKFLOW_REQUEST_COMPLETED',
  WORKFLOW_INITIATOR_LIST_VIEWED = 'WORKFLOW_INITIATOR_LIST_VIEWED',
  WORKFLOW_AGENT_LIST_VIEWED = 'WORKFLOW_AGENT_LIST_VIEWED',
  WORKFLOW_STEP_ACTIONED = 'WORKFLOW_STEP_ACTIONED',
  WORKFLOW_DETAIL_VIEWED = 'WORKFLOW_DETAIL_VIEWED',
  WORKFLOW_REQUEST_BLOCKED = 'WORKFLOW_REQUEST_BLOCKED',
  // Goals
  GOAL_CREATED = 'GOAL_CREATED',
  GOAL_UPDATED = 'GOAL_UPDATED',
  // Courses
  COURSE_MINIAPP_ENTERED = 'COURSE_MINIAPP_ENTERED',
  COURSE_DETAILS_VIEWED = 'COURSE_DETAILS_VIEWED',
  COURSE_STARTED = 'COURSE_STARTED',
  COURSE_TASK_FINISHED = 'COURSE_TASK_FINISHED',
  COURSE_TASK_STARTED = 'COURSE_TASK_STARTED',
  COURSE_MODULE_FINISHED = 'COURSE_MODULE_FINISHED',
  COURSE_FINISHED = 'COURSE_FINISHED',
  // People experience
  SURVEY_ANSWER_STARTED = 'PX_SURVEY_ANSWER_STARTED',
  SURVEY_SENT = 'PX_SURVEY_ANSWER_SENT',
  PARTICIPATION_VIEWED = 'PX_PARTICIPATION_VIEWED',
  HEATMAP_VIEWED = 'PX_HEATMAP_VIEWED',
  // TimeTracking
  TIME_TRACKING_REPORT_DOWNLOADED = 'TIME_TRACKING_REPORT_DOWNLOADED',
}

export enum UserProperties {
  INSTANCE_ID = 'Instance ID',
  USERNAME = 'Username',
  INSTANCE_NAME = 'Instance Name',
}

export enum Destination {
  WHATSAPP = 'whatsapp',
  HELP_CENTER = 'helpCenter',
}

export enum LoginTypes {
  AZURE = 'AZURE',
  OKTA = 'OKTA',
  REGULAR = 'REGULAR',
  GOOGLE = 'GOOGLE',
  OTP = 'OTP',
}

export enum Modules {
  FEED = 'Feed',
  NEWS = 'News',
  TICKETS = 'Tickets',
  CHATS = 'Chats',
  FORMS = 'Forms',
  PEOPLE = 'People',
  FILES = 'Files',
  TRAININGS = 'Trainings',
  SURVEYS = 'Surveys',
  ONBOARDING = 'Onboarding',
  LIBRARY = 'Library',
  ACKNOWLEDGEMENTS = 'Acknowledgements',
  GROUPS = 'Groups',
  DOCUMENTS = 'Documents',
  KNOWLEDGELIBRARIES = 'KnowledgeLibraries',
  TIMEOFF = 'TimeOff',
  PEOPLEEXPERIENCE = 'PeopleExperience',
  MARKETPLACE = 'Marketplace',
  PERFORMANCE = 'PerformanceReview',
  WORKFLOWS = 'Workflows',
  GOALS = 'Goals',
  COURSES = 'Courses',
}

export enum SharedReviewOrigin {
  BOSS = 'boss',
  ADMIN = 'admin',
}
